import * as React from 'react'
import { SVGProps } from 'react'
const SvgSizeChart = (props: SVGProps<SVGSVGElement>) => (
  <svg width={22} height={20} viewBox="0 0 22 20" fill="none" {...props}>
    <path d="M6 2h14H6Z" fill="#000" />
    <path
      d="M6 2h14"
      stroke="#000"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 10h13H2Z" fill="#000" />
    <path
      d="M2 10h13"
      stroke="#000"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 18h10-10Z" fill="#000" />
    <path
      d="M10 18h10"
      stroke="#000"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgSizeChart
